import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import { createComponent, PropTypes } from "../../../../wayin-react";
import { toUIProps } from "../../../../util";
import Panel from "../../panel";
import SharingField from "./sharing-field";
import Tooltip from "../../../core/tooltip";
import { positions, sizes, social } from "../../../../enums";
var SharingForm = createComponent({
  displayName: 'SharingForm',
  propTypes: {
    formConfig: PropTypes.array,
    formValues: PropTypes.shape({
      picture: PropTypes.string,
      asset: PropTypes.string,
      link: PropTypes.string,
      title: PropTypes.string,
      byline: PropTypes.string,
      message: PropTypes.string,
      allowImport: PropTypes.bool
    }),
    name: PropTypes.string,
    network: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    assetUploaderConfig: PropTypes.shape({
      prefix: PropTypes.string,
      assetCategories: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string
      })),
      libraryRef: PropTypes.string,
      containerRef: PropTypes.string
    })
  },
  defaultProps: {
    formConfig: [],
    formValues: {},
    name: undefined,
    network: undefined,
    assetUploaderConfig: {
      prefix: '',
      assetCategories: [],
      libraryRef: '',
      containerRef: ''
    }
  },
  lifecycles: {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return this.props.formValues !== nextProps.formValues;
    }
  },
  handlers: {
    fieldChanged: function fieldChanged(p) {
      return function (e, value, field) {
        p.setHasError(field.hasError);
        p.onChange(e, value);
      };
    }
  },
  state: {
    hasError: {
      value: false,
      updater: function updater(_updater, p) {
        return {
          setHasError: function setHasError(p) {
            return _updater(p);
          }
        };
      }
    }
  },
  render: function render(p) {
    var _context;

    return /*#__PURE__*/React.createElement(Panel, {
      hasBorder: false,
      padding: {
        horizontal: null,
        vertical: sizes.X1
      }
    }, _mapInstanceProperty(_context = p.formConfig).call(_context, function (field, i) {
      return /*#__PURE__*/React.createElement(Tooltip, {
        isInline: false,
        tooltip: getSharingFieldTooltip(p, field.name),
        key: i
      }, /*#__PURE__*/React.createElement(SharingField, _extends({
        key: i,
        formName: p.name,
        network: p.network,
        onChange: p.fieldChanged,
        value: p.formValues[field.name],
        assetUploaderConfig: p.assetUploaderConfig
      }, field)));
    }, this));
  }
});

function getSharingFieldTooltip(p, fieldName) {
  return networkTooltips[p.network][fieldName];
}

var networkTooltips = {
  "default": {},
  facebook: {
    title: 'Blue link title field. Max of 100 characters.',
    byline: 'Byline below the title often used to show the domain the user will be linked to.',
    message: 'Caption appears below heading and byline.'
  },
  google: {},
  pinterest: {
    message: 'Enter the default Pinterest message that you would like users to share. An image is required.'
  },
  twitter: {
    message: 'Enter the default Twitter message that you would like users to share. A link to your experience will be added to the end of your Tweet which will turn into a 23 character “t.co” link but will be displayed as it was entered.'
  }
};
export default SharingForm;
//# sourceMappingURL=sharing-form.js.map